var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99937C0 7.65823 0.167411 7.31691 0.502232 7.05692L9.07366 0.390605C9.7433 -0.130202 10.8281 -0.130202 11.4978 0.390605C12.1674 0.911411 12.1674 1.75512 11.4978 2.27592L4.13572 7.99937L11.4964 13.7241C12.1661 14.2449 12.1661 15.0886 11.4964 15.6094C10.8268 16.1302 9.74196 16.1302 9.07232 15.6094L0.500893 8.94308C0.166072 8.68267 0 8.34102 0 7.99937Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseRight);
export default __webpack_public_path__ + "static/media/purchase-right.016f9ca3ce48d017446fd501280fa6fa.svg";
export { ForwardRef as ReactComponent };